import React, { Component } from "react";
import {
  Col,
  Row,
  FormGroup,
  Label,
  CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import {
  createTaxi,
  updateTaxi,
  getTaxiById,
  getTaxiList,
  removeTaxi,
} from "../../Endpoint/Admin/index";
import { toast } from "react-toastify";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { ConsolePage } from "../../components/Console/ConsoleLayout";
import { canWrite } from "../../services/PermissionService";
import BranchAssignment from "../../components/Common/BranchAssignment";
import {
  C, Panel, MiniStat, StatRow, SearchPill, Table, Btn, IconBtn, MODAL_CSS,
} from "../../components/Console/ConsoleUI";

/**
 * Taxi catalogue — the fixed-price cars a guest can pick from in the app.
 *
 * A reskin, drawn to the console's fleet screen (D5): the same create, update,
 * fetch-by-id, list and remove calls, the same multipart FormData with the
 * same field names, and the same AvForm validation inside the editor.
 *
 * The previous screen built its Update / Remove controls by writing JSX onto
 * each record (`x.update`, `x.remove`) and overwriting `x.image` with an <img>.
 * That mutation is gone — the records are kept as the API returned them and
 * the controls are rendered by the column, so a second load cannot find an
 * element where a URL should be.
 */

const CSS = MODAL_CSS;

const money = (n) => `$${Number(n || 0).toFixed(2)}`;

/**
 * Taxi photo. Uploaded images are stored as plain paths on older records, so a
 * broken src is expected rather than exceptional — it falls back to a tinted
 * car glyph instead of the browser's torn-image mark.
 */
class Thumb extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: !props.src };
  }

  render() {
    const size = this.props.size || 54;
    const box = {
      width: size, height: size, borderRadius: size > 60 ? 16 : 12,
      objectFit: "cover", display: "block", border: `1px solid ${C.tint}`,
    };
    if (this.state.failed) {
      return (
        <div style={{ ...box, background: C.iconTint, display: "grid", placeItems: "center" }}>
          <span className="ms" style={{ fontSize: size > 60 ? 38 : 24, color: C.sand }}>local_taxi</span>
        </div>
      );
    }
    return (
      <img
        src={this.props.src}
        alt={this.props.alt || ""}
        style={box}
        onError={() => this.setState({ failed: true })}
      />
    );
  }
}

class Taxi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invalidFile: false,
      previewImage: undefined,
      items: [],
      isLoaded: false,
      updatemodal: false,
      modal: false,
      name: "",
      type: "",
      amount: "",
      // Branch scope. Empty branchIds = offered at every branch, the
      // master-catalog default.
      branchIds: [],
      excludedBranchIds: [],
      branchPriceOverrides: [],
      // View-only filter. It never changes what is fetched.
      search: "",
      roomHospitalityServiceId: null,
      selectedFile: null, // to store selected file
      handleResponse: null, // handle the API response
      imageUrl: null, // to store uploaded image path
      invalidImage: null,
      selectedFileName: "",
      taxiId: "",
      success: {},
      breadcrumbItems: [
        { title: "", link: "#" },
        { title: " ", link: "#" },
      ],
      customchk: true,
      toggleSwitch: true,
    };
    this.reader = new FileReader();
    this.handleChange = this.handleChange.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.getALlluser = this.getALlluser.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
      name: "",
      type: "",
      amount: "",
      branchIds: [],
      excludedBranchIds: [],
      branchPriceOverrides: [],
      previewImage: "",
      taxiId: "",
      selectedOption: null,
      invalidImage: null,
    });
  }

  updatetoggle() {
    this.setState({
      updatemodal: !this.state.updatemodal,
    });
  }

  handleCloseModal() {
    this.setState({
      updatemodal: false,
      modal: false,
    });
  }

  onFileChange(event) {
    const imageFile = event.target.files[0];

    if (!imageFile.name.match(/\.(jpg|jpeg|png)$/)) {
      this.setState({
        invalidImage: "Please select valid image.",
        previewImage: URL.createObjectURL(event.target.files[0]),
      });
      return false;
    } else {
      this.setState({
        selectedFile: event.target.files[0],
        previewImage: URL.createObjectURL(event.target.files[0]),
        invalidImage: null,
      });
    }
  }

  handleChange = (e) => {
    this.setState(
      {
        [e.target.id]: e.target.value,
      },
      () => {}
    );
  };

  handleSubmit(e) {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", this.state.name);
    formData.append("type", this.state.type);
    formData.append("amount", this.state.amount);
    formData.append("branchIds", JSON.stringify(this.state.branchIds || []));
    formData.append(
      "excludedBranchIds",
      JSON.stringify(this.state.excludedBranchIds || [])
    );
    formData.append(
      "branchPriceOverrides",
      JSON.stringify(this.state.branchPriceOverrides || [])
    );
    formData.append("taxiImage", this.state.selectedFile);
    formData.append("taxiId", this.state.taxiId);

    if (this.state.taxiId == "" || this.state.taxiId == null) {
      createTaxi(formData)
        .then((response) => {
          if (response.status !== 200) {
            toast.error(response.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: response.status === 200,
                message: "success",
                hospitalityServiceName: "",
                selectedFile: null, // to store selected file
                handleResponse: null, // handle the API response
                imageUrl: null, // to store uploaded image path
                invalidImage: null,
                selectedFileName: "",
                previewImage: "",
                taxiId: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();

            toast.success("Taxi added successfully");
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    } else {
      updateTaxi(formData)
        .then((updateResults) => {
          if (updateResults.status !== 200) {
            toast.error(updateResults.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: updateResults.status === 200,
                message: "success",
                taxiId: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();

            toast.success("Taxi updated successfully");
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    }
  }

  getALlluser() {
    getTaxiList().then((result) => {
      this.setState({
        isLoaded: true,
        items: result.data || [],
      });
    });
  }

  componentDidMount() {
    this.getALlluser();
  }

  editTaxi(id) {
    getTaxiById(id)
      .then((results) => {
        this.setState({
          name: results.data.name,
          type: results.data.type,
          amount: results.data.amount,
          branchIds: (results.data.branchIds || []).map((b) => String(b)),
          excludedBranchIds: (results.data.excludedBranchIds || []).map((b) => String(b)),
          branchPriceOverrides: results.data.branchPriceOverrides || [],

          previewImage: results.data.image,
          selectedFile: results.data.imageFile,
          taxiId: results.data._id,
        });
      })
      .catch((error) => {
        toast.error("error");
      });
    this.toggle();
  }

  removetaxi(id) {
    removeTaxi(id)
      .then((results) => {
        toast.success(results.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        this.getALlluser();
      })
      .catch((error) => {
        toast.error("error");
      });
  }

  visibleRows = () => {
    const q = this.state.search.trim().toLowerCase();
    if (!q) return this.state.items;
    return this.state.items.filter((t) =>
      [t.name, t.type].filter(Boolean).join(" ").toLowerCase().includes(q)
    );
  };

  columns = () => [
    {
      key: "name",
      label: "Taxi",
      render: (t) => (
        <div style={{ display: "flex", alignItems: "center", gap: 13 }}>
          <Thumb src={t.image} alt={t.name} />
          <div>
            <div style={{ fontSize: 15, color: C.ink }}>{t.name}</div>
            <div style={{ marginTop: 2, fontSize: 12, color: C.taupeLight }}>
              {t.type || "type not set"}
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "amount",
      label: "Fare",
      width: 140,
      render: (t) => (
        <span style={{ fontSize: 15, fontWeight: 500, color: C.ink }}>{money(t.amount)}</span>
      ),
    },
    ...(canWrite()
      ? [
          {
            key: "actions",
            label: "",
            align: "right",
            width: 100,
            render: (t) => (
              <div style={{ display: "flex", gap: 6, justifyContent: "flex-end" }}>
                <IconBtn
                  icon="edit"
                  title="Edit taxi"
                  onClick={() => this.editTaxi(t._id.toString(), t)}
                />
                <IconBtn
                  icon="delete"
                  title="Remove taxi"
                  tone="bad"
                  onClick={() => this.removetaxi(t._id.toString())}
                />
              </div>
            ),
          },
        ]
      : []),
  ];

  render() {
    const { handleResponse, invalidImage, items, previewImage, isLoaded, search, taxiId } = this.state;
    const rows = this.visibleRows();

    const priced = items.filter((t) => Number(t.amount) > 0);
    const dearest = priced.length ? Math.max(...priced.map((t) => Number(t.amount))) : 0;
    const cheapest = priced.length ? Math.min(...priced.map((t) => Number(t.amount))) : 0;
    const types = new Set(items.map((t) => t.type).filter(Boolean)).size;

    return (
      <ConsolePage
        title="Taxis"
        subtitle={`${items.length} car${items.length === 1 ? "" : "s"} in the catalogue${isLoaded ? "" : " · loading…"}`}
        actions={
          <React.Fragment>
            <SearchPill
              value={search}
              onChange={(v) => this.setState({ search: v })}
              placeholder="Taxi or type"
              width={230}
            />
            {canWrite() && (
              <Btn icon="add" onClick={this.toggle}>
                Add taxi
              </Btn>
            )}
          </React.Fragment>
        }
      >
        <style>{CSS}</style>

        <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
          <StatRow>
            <MiniStat label="Cars listed" value={items.length} hint="offered in the app" />
            <MiniStat label="Distinct types" value={types} hint="sedan, van and so on" />
            <MiniStat label="Cheapest fare" value={priced.length ? money(cheapest) : "—"} hint="flat rate" />
            <MiniStat label="Dearest fare" value={priced.length ? money(dearest) : "—"} hint="flat rate" />
          </StatRow>

          <Panel style={{ padding: "6px 10px" }}>
            {!isLoaded ? (
              <div style={{ padding: "48px 0", textAlign: "center", color: C.taupeLight }}>
                Loading taxis…
              </div>
            ) : (
              <Table columns={this.columns()} rows={rows} empty="No taxis in the catalogue yet" />
            )}
          </Panel>
        </div>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={`con-modal ${this.props.className || ""}`}
        >
          <ModalHeader toggle={this.toggle}>
            {taxiId ? "Edit taxi" : "Add a taxi"}
          </ModalHeader>
          <ModalBody>
            <AvForm onValidSubmit={this.handleSubmit}>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="name">Name</Label>
                    <AvField
                      type="text"
                      value={this.state.name}
                      onChange={this.handleChange}
                      id="name"
                      name="name"
                      required
                                  errorMessage="Name is required"
                                />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="type">Type</Label>
                    <AvField
                      type="text"
                      value={this.state.type}
                      onChange={this.handleChange}
                      id="type"
                      name="type"
                      required
                                  errorMessage="Type is required"
                                />
                  </FormGroup>
                </Col>
              </Row>

              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="amount">Amount</Label>
                    <AvField
                      type="number"
                      value={this.state.amount}
                      onChange={this.handleChange}
                      id="amount"
                      name="amount"
                      required
                                  errorMessage="Amount is required"
                                />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label htmlFor="file">Taxi image</Label>
                    <div className="custom-file">
                      <AvField
                        tag={CustomInput}
                        name="file"
                        id="file"
                        type="file"
                        accept="image/*"
                        onChange={this.onFileChange}
                        required
                                  errorMessage="Taxi image is required"
                                />
                      <Label className="custom-file-label" htmlFor="customFile">
                        Choose file
                      </Label>
                    </div>
                  </FormGroup>
                </Col>
              </Row>

              {previewImage && (
                <div style={{ marginTop: 4, marginBottom: 16 }}>
                  {/* Keyed on the source so switching records (or picking a new
                      file) remounts the fallback rather than keeping the last
                      record's "broken" verdict. */}
                  <Thumb key={previewImage} src={previewImage} alt="" size={96} />
                </div>
              )}

              {/* Which branches offer this taxi, and what each one charges.
                  A new taxi starts at every branch, matching the
                  master-catalog default for every other item type. */}
              <Row form>
                <Col xs={12}>
                  <BranchAssignment
                    branchIds={this.state.branchIds}
                    excludedBranchIds={this.state.excludedBranchIds}
                    overrides={this.state.branchPriceOverrides}
                    priceFields={[{ key: "amount", label: "Fare" }]}
                    onChange={({ branchIds, excludedBranchIds, overrides }) =>
                      this.setState({
                        branchIds,
                        excludedBranchIds,
                        branchPriceOverrides: overrides,
                      })
                    }
                  />
                </Col>
              </Row>

              {invalidImage && (
                <div style={{ marginBottom: 12, fontSize: 13, color: C.red }}>{invalidImage}</div>
              )}
              {this.state.selectedFileName && (
                <div style={{ marginBottom: 12, fontSize: 13, color: C.taupe }}>
                  {this.state.selectedFileName}
                </div>
              )}
              {handleResponse && (
                <div
                  style={{
                    marginBottom: 12, fontSize: 13,
                    color: handleResponse.isSuccess ? "#2f7d33" : C.red,
                  }}
                >
                  {handleResponse.message}
                </div>
              )}

              <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 8 }}>
                <Btn kind="quiet" onClick={this.handleCloseModal}>
                  Cancel
                </Btn>
                {/* Submit stays a real submit button so AvForm's validation
                    still gates it — the kit's Btn renders type="button". */}
                <button
                  type="submit"
                  style={{
                    display: "inline-flex", alignItems: "center", justifyContent: "center",
                    height: 42, padding: "0 18px", borderRadius: 21, border: "none",
                    background: C.brown, color: "#fff", fontSize: 14,
                    fontFamily: "inherit", cursor: "pointer",
                  }}
                >
                  {taxiId ? "Update taxi" : "Add taxi"}
                </button>
              </div>
            </AvForm>
          </ModalBody>
        </Modal>
      </ConsolePage>
    );
  }
}

export default Taxi;
